import React from 'react'
import { Props } from '../@types'


const style = {
  title: {
    backgroundColor: '#252525',
    padding: '15px',
    fontSize: '16px'
  }
}

function Header(props: Props) {
  return (
    <div style={style.title} className={props.className}>
      <h1>GIS数据管理</h1>
    </div>
  )
}

export default Header